/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './procedure-price.reducer';

export const ProcedurePriceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const procedurePriceEntity = useAppSelector(state => state.procedurePrice.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="procedurePriceDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.procedurePrice.detail.title">ProcedurePrice</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.id">Id</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.active">Active</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.timestampentry}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.price">Price</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.price}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.discount}</dd>
          <dt>
            <span id="priceType">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.priceType">Price Type</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.priceType}</dd>
          <dt>
            <span id="multiplierApplied">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.multiplierApplied">Multiplier Applied</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.multiplierApplied ? 'true' : 'false'}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.endDate}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.procedurePrice.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{procedurePriceEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedurePrice.scheme">Scheme</Translate>
          </dt>
          <dd>{procedurePriceEntity.scheme ? procedurePriceEntity.scheme.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedurePrice.procedure">Procedure</Translate>
          </dt>
          <dd>{procedurePriceEntity.procedure ? procedurePriceEntity.procedure.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedurePrice.exam">Exam</Translate>
          </dt>
          <dd>{procedurePriceEntity.exam ? procedurePriceEntity.exam.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/procedure-price" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/procedure-price/${procedurePriceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProcedurePriceDetail;
